<template>
	<div>
		<!-- 功能按钮 -->
		<buttonlist @help="help" @add="add" @reflash="reflash" @del="delall" ref="SetBtn"></buttonlist>
		<!-- 功能按钮 -->
		<!-- 表格 -->
		<el-table
			:data="datajson"
			v-loading="loading"
			:highlight-current-row="false"
			show-overflow-tooltip="true"
			border
			stripe
			size="mini"
			:height="tableHeight"
			@cell-dblclick="editInfo"
			tab-click="selectInfo(0)"
			header-row-class-name="headerclass"
			@selection-change="handleSelectionChange"
			style="width: 100%; margin-top:0px"
			ref="singleTable"
		>
			<el-table-column type="selection"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Product_Stage_Code" label="ID" v-if="false"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Product_Stage_Code" :label="$t('getapi[6192]')" width="100"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Product_Stage_Name" :label="$t('getapi[6193]')" width="200"></el-table-column>
			<el-table-column :label="$t('getapi[6048]')" width="80">
				<template slot-scope="scope">
					<el-button @click.native.prevent="edit(scope)" type="text" size="small" :disabled="!CanEdit">{{$t('getapi[34]')}}</el-button>
					<el-popconfirm :confirmButtonText="$t('getapi[6109]')" :cancelButtonText="$t('getapi[6851]')" icon="el-icon-info" iconColor="red" :title="$t('getapi[6049]')" @onConfirm="del(scope)">
						<el-button slot="reference" type="text" :disabled="!CanDel" size="small">{{$t('getapi[40]')}}</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<!-- 表格 -->
		<!-- 分页 -->
		<el-row class="page">
			<el-col :span="12">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="[50, 100, 200, 300, 400]"
					:page-size="PageSize"
					background
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="12">
				<div style="text-align: right;line-height:30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>
		<!-- 分页 -->
		<!-- 编辑弹框 -->
		<el-dialog v-dialogDrag :visible.sync="isVisible" :title="$t('getapi[6194]')" width="30%" :close-on-click-modal="false">
			<el-divider></el-divider>
			<div :style="{border:'0px solid #DCDFE6'}">
				<table>
					<tr>
						<td>{{$t('getapi[6192]')}}</td>
						<td><el-input v-model="formInline.Product_Stage_Code"></el-input></td>
						<td>{{$t('getapi[6193]')}}</td>
						<td><el-input v-model="formInline.Product_Stage_Name"></el-input></td>
					</tr>
				</table>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button @click="isVisible = false">{{$t('getapi[6]')}}</el-button>
				<el-button type="primary" @click="sava">{{$t('getapi[937]')}}</el-button>
			</span>
		</el-dialog>
		<!-- 编辑弹框 -->
	</div>
</template>

<script>
import Common from '@/components/Common';
export default {
	name: 'ecnnew',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			formInline: {
				Product_Stage_Code:'',
				Product_Stage_Name:''
			},
			ids: '',
			cgzb: [],
			showloading: '',
			isVisible: false,
			editvisi: false,
			DbTbNames: '', //表名
			datajson: [],
			PageIndex: 1,
			PageSize: this.$http.getPageSize('ecnnew'),
			SelectIndex: 1,
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			isShowEdit: false, // 是否显示编辑页面
			selectIDData: '', // 选择的数据的ID集合
			isEdit: true, // 是否新增
			CanEdit:false,//可以编辑
			CanDel:false,//可以删除
            scrollTop:0,
		};
	},
	create() {},
	beforeMount() {
		console.log('beforeMount');
	},
	mounted() {
		console.log('mounted');
		let that = this;
		that.intidata();
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })

    },
	methods: {
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6127]"),this.$t("getapi[18]"));
        },
		//type
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			//可以编辑
			that.CanEdit=false;
			//可以删除
			that.CanDel=false;
			if (that.$limits.authority('plv2', 35, 1) == 1) {
				//只读权
				that.$refs.SetBtn.SetButtonEnable('refresh');
			}
			else if (that.$limits.authority('plv2', 35, 1) == 2) {
				if (that.$limits.authority('plv3', 35,1) == 0) {
					that.$refs.SetBtn.SetButtonEnable('refresh');
				}
				//操作权
				if (that.$limits.authority('plv3', 35,1) == 1) {
					that.CanEdit=true;
					//编辑级
					that.$refs.SetBtn.SetButtonEnable('create,refresh');
				}
				if (that.$limits.authority('plv3', 35, 1) == 2) {
					//可以删除
					that.CanEdit=true;
					that.CanDel=true;
					//删除级
					if (that.selectIDData.length > 0) {
						that.$refs.SetBtn.SetButtonEnable('create,del,refresh');
					} else {
						that.$refs.SetBtn.SetButtonEnable('create,refresh');
					}                   
				}
			}
			else{
				that.$refs.SetBtn.SetButtonEnable('refresh');
				if (that.$limits.authority('plv2', 35, 1) > 0) {
					if (that.total > 0) {
						that.$refs.SetBtn.SetButtonEnable('refresh');
					}
				}
			}
		},
		//修改页数
		handleSizeChange(val) {
			this.PageSize = val;
            this.$http.savePageSize('ecnnew',val)
			this.intidata();
			this.authority();
		},
		//跳页
		handleCurrentChange(val) {
			this.PageIndex = val;
			this.intidata();
			this.authority();
		},
		//编辑
		editInfo(row) {
			let that = this;
		},
		handleSelectionChange(val) {
			let that = this;
			that.selectIDData = '';
			for (let i = 0; i < val.length; i++) {
				that.selectIDData += val[i].Product_Stage_Code + ',';
			}
			console.log(that.selectIDData);
			that.authority();
		},
		// 获取数据
		intidata() {
			let that = this;
			that.loading = true;
			this.isVisible = false;
			that.$http.urlpost('/Basic/ECN/GetECNProductStageList', {}, function(res) {
				console.log(res);
				if (res.Success == 1) {
					that.datajson = res.DataContent;
					that.total = res.Totals;
					that.DbTbNames = res.DbTbNames;
				}
				that.loading = false;
				that.authority();
			});
		},
		sava() {
			let that = this;
			that.loading = true;
			let parm = new Array();
			that.formInline.IsEdit = that.editvisi?0:1;
			parm.push(that.formInline);
			that.$http.urlpost('/Basic/ECN/SaveECNProductStage', parm, function(res) {
				console.log(res);
				if (res.Success == 1) {
					that.$message.success(that.$t('getapi[3153]'));//'保存成功'
					that.editvisi = false;
					that.intidata();
				}
				that.loading = false;
				that.authority();
			});
		},
		delf() {
			let that = this;
			let parm = {
				ids: that.ids
			};
			console.log(parm);
			that.$http.urlpost('/Basic/ECN/DeleteECNProductStageByID', parm, function(res) {
				console.log(res);
				if (res.Success == 1) {
					that.$message.success(that.$t('getapi[659]'));//'删除成功'
					that.intidata();
				}
			});
		},
		// 编辑
		edit(jsd) {
			this.formInline.Product_Stage_Code = jsd.row.Product_Stage_Code;
			this.formInline.Product_Stage_Name = jsd.row.Product_Stage_Name;
			this.editvisi = true;
			this.isVisible = true;
		},
		// 删除
		del(jsd) {
			this.ids = jsd.row.Product_Stage_Code + ',';
			this.delf();
		},
		//批量删除
		delall() {
			let that = this;
			that.ids = this.selectIDData;
			that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'此操作将永久删除该数据, 是否继续?'
				confirmButtonText: that.$t('getapi[1146]'),
				cancelButtonText: that.$t('getapi[2054]'),
				type: 'warning'
			})
				.then(() => {
					that.delf();
				})
				.catch(() => {});
		},
		// 新增
		add() {
			let that = this;
			that.editvisi = false;
			that.isVisible = true;
			that.formInline = {
				Product_Stage_Code: '',
				Product_Stage_Name: ''
			};
		},
		// 刷新
		reflash() {
			this.intidata();
		}
	}
};
</script>

<style lang="scss" scoped>
	table {
		border-collapse: separate;
		border-spacing: 0px 5px;
		td {
			padding-left: 3px;
			white-space: pre;
		}
	}
</style>
